import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import "../header/header.scss";

const Header = ({ images }) => {
    const [middleWidth, setMiddleWidth] = useState("50vw");
    const [middleHeight, setMiddleHeight] = useState("65vh");
    const [middleLeft, setMiddleLeft] = useState("25vw");
    const [middleOpacity, setMiddleOpacity] = useState("1");
    const [leftLeft, setLeftLeft] = useState("-13vw");
    const [rightLeft, setRightLeft] = useState("73vw");

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;

            const newMiddleWidth = Math.min(100, 50 + scrollPosition / 5);
            setMiddleWidth(`${newMiddleWidth}vw`);

            const newMiddleHeight = Math.min(100, 65 + scrollPosition / 10);
            setMiddleHeight(`${newMiddleHeight}vh`);

            const newMiddleLeft = Math.max(0, 25 - scrollPosition / 10);
            setMiddleLeft(`${newMiddleLeft}vw`);

            const newMiddleOpacity = Math.max(0.7, 1 - scrollPosition / 1000);
            setMiddleOpacity(`${newMiddleOpacity}`);

            const newLeftLeft = Math.max(-50, -13 - scrollPosition / 10);
            setLeftLeft(`${newLeftLeft}vw`);

            const newRightLeft = Math.min(100, 73 + scrollPosition / 10);
            setRightLeft(`${newRightLeft}vw`);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <div className="header">
            <motion.div
                className="top"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
            >
                <div dangerouslySetInnerHTML={{ __html: images[0].content.rendered }} />
            </motion.div>
            <div className="gallery">
                <div className="left" style={{ left: leftLeft }}>
                    <motion.img
                        src={images[3].acf.image.url}
                        alt=""
                        initial={{ opacity: 0, y: 200 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: "easeOut" }}
                    />
                    <motion.img
                        src={images[2].acf.image.url}
                        alt=""
                        initial={{ opacity: 0, y: 200 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease: "easeOut" }}
                    />
                </div>
                <motion.div
                    className="middle"
                    style={{ width: middleWidth, height: middleHeight, left: middleLeft }}
                    initial={{ opacity: 0, y: 100 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                >
                    <img src={images[4].acf.image.url} alt="" style={{ opacity: middleOpacity }} />
                    <h2>seit 1818</h2>
                    <div className="socialIcons">
                        <span>Folgt uns auf</span>
                        <Link to="https://www.facebook.com/mkstlorenzen" target="blank">
                            <FacebookOutlinedIcon />
                        </Link>
                        <Link to="https://www.instagram.com/mkstlorenzen/" target="blank">
                            <InstagramIcon />
                        </Link>
                        <Link to="https://www.youtube.com/@mkstlorenzen" target="blank">
                            <YouTubeIcon />
                        </Link>
                    </div>
                </motion.div>
                <motion.div
                    className="right"
                    style={{ left: rightLeft }}
                    initial={{ opacity: 0, y: 300 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                >
                    <img src={images[1].acf.image.url} alt="" />
                </motion.div>
            </div>
        </div>
    );
};

export default Header;
